"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseProcedure = void 0;
/**
 * Base contract builder shared by every per-procedure module in `procedures/`.
 *
 * `baseProcedure` carries the typed-meta declaration (`ProcedureMeta`) and the
 * cross-cutting error specs (`sharedErrorSpecs`) so every procedure inherits
 * them. Per-procedure modules extend it with
 * `.route(...).input(...).output(...).errors(...)` and export the resulting
 * subtree, which `contract.ts` composes into the full `AppContract`.
 */
const contract_1 = require("@orpc/contract");
const errors_1 = require("./errors");
exports.baseProcedure = contract_1.oc.$meta({}).errors(errors_1.sharedErrorSpecs);
//# sourceMappingURL=base.js.map